import { Injectable, computed, inject, signal } from '@angular/core';
import { AuthService } from './auth.service';

const RESEND_COOLDOWN_SECONDS = 60;

@Injectable({ providedIn: 'root' })
export class EmailVerifyService {
  private authService = inject(AuthService);

  isResending = signal(false);
  resendMessage = signal('');
  cooldownSecondsLeft = signal(0);
  canResend = computed(() => this.cooldownSecondsLeft() <= 0 && !this.isResending());

  private cooldownTimer: ReturnType<typeof setInterval> | null = null;

  async resend(): Promise<void> {
    if (!this.canResend()) return;
    this.isResending.set(true);
    this.resendMessage.set('');
    try {
      await this.authService.resendVerificationEmail();
      this.resendMessage.set('Verification email sent — check your inbox.');
      this.startCooldown();
    } catch (err) {
      this.resendMessage.set(this.authService.mapFirebaseAuthError(err));
    } finally {
      this.isResending.set(false);
    }
  }

  private startCooldown(seconds = RESEND_COOLDOWN_SECONDS): void {
    if (this.cooldownTimer) {
      clearInterval(this.cooldownTimer);
    }
    this.cooldownSecondsLeft.set(seconds);
    this.cooldownTimer = setInterval(() => {
      this.cooldownSecondsLeft.update((s) => {
        if (s <= 1) {
          if (this.cooldownTimer) {
            clearInterval(this.cooldownTimer);
            this.cooldownTimer = null;
          }
          return 0;
        }
        return s - 1;
      });
    }, 1000);
  }
}
